/* @flow */
export default {
  dashboardIcon: 'dashboard',
  applicationNetworksIcon: 'device_hub',
  gatewaysIcon: 'router',
  endDevicesIcon: 'select_all',
  deviceProfilesIcon: 'assignment',
  networkProfilesIcon: 'assignment',
  operationsIcon: 'settings_remote',
  policiesIcon: 'lock',
  keyIcon: 'key-variant',
  serviceApiKeyIcon: 'mdi-folder-key-network',
  peopleIcon: 'supervisor_account',
  supportIcon: 'help_outline',
  orgIcon: 'business',
  orgsIcon: 'group_work',
  myAccountIcon: 'account_circle',
  logOutIcon: 'exit_to_app',
}



// WEBPACK FOOTER //
// ./src/icons.js